<template>
  <div>
    <SimpleFieldList
      :disabled="disabled"
      :operators="operators"
      :spr="tenderDepartments"
      :value.sync="mutableValue"/>
  </div>
</template>
<script>
import SimpleFieldList from 'components/automation/conditions/default/simpleFieldList.vue'

import { mapGetters } from 'vuex'
import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()
/**
 * Підрозділ
 */
export default {
  name: 'tenderDepartment',
  methods: {
    async getValues() {
      await tender_api.getCurrentOrganizationDepartments()
        .then(response => {
          this.$store.commit('setDepartmentsToState', response)
        })
    }
  },
  computed: {
    ...mapGetters({
      storedCurrentOrganization: 'getCurrentOrganization',
    }),
    tenderDepartments() {
      return this.$store.getters.getDepartments.map(i => ({
        key: i.id,
        label: i.title
      }))
        .sort((a,b) => a.label?.localeCompare(b.label))
    },
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  components: {
    SimpleFieldList
  },
  async created() {
    if (!this.tenderDepartments?.length) {
      await this.getValues()
    }
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
